import { createContext, useContext } from 'react'

export interface MobileNavContextValue {
  openMobileNav: () => void
}

export const MobileNavContext = createContext<MobileNavContextValue | undefined>(undefined)

export const useMobileNav = () => {
  const ctx = useContext(MobileNavContext)
  return ctx?.openMobileNav ?? (() => {})
}
